import { Anything } from 'src/types';
import {
  IconCalendar,
  IconCalendarTime,
  IconAlarm,
  IconMapPin,
  IconAlignJustified,
  IconLink,
  IconPhotoSearch,
  IconPhotoPlus,
  IconRuler2,
  IconScaleOutline,
  IconCoinEuro,
  IconUser,
  IconNewSection,
  IconQuestionMark,
  IconLocation,
  IconWand,
  IconTemperature,
} from '@tabler/icons';

import { NEW_CUSTOM_TYPE } from 'src/Components/Anything/SupportedTypes';
import styled from 'styled-components';

type TypeIconRawProps = {
  type: Anything['type'] | typeof NEW_CUSTOM_TYPE;
  className?: string;
};
const TypeIconRaw = ({ type, className = '' }: TypeIconRawProps) => {
  switch (type) {
    case 'POSITION':
      return <IconMapPin className={className} />;
    case 'LOCATION':
      return <IconLocation className={className} />;
    case 'TEMPATURE':
      return <IconTemperature className={className} />;
    case 'DATE':
      return <IconCalendar className={className} />;
    case 'DATETIME':
      return <IconCalendarTime className={className} />;
    case 'TEXT':
      return <IconAlignJustified className={className} />;
    case 'URL':
      return <IconLink className={className} />;
    case 'AUTHOR':
      return <IconUser className={className} />;
    case 'PRICE':
      return <IconCoinEuro className={className} />;
    case 'WEIGHT':
      return <IconScaleOutline className={className} />;
    case 'LENGTH':
      return <IconRuler2 className={className} />;
    case 'IMAGE_URL':
      return <IconPhotoSearch className={className} />;
    case 'IMAGE_S3':
      return <IconPhotoPlus className={className} />;
    case 'TIME':
      return <IconAlarm className={className} />;
    case 'VIRTUAL':
      return <IconWand className={className} />;
    case NEW_CUSTOM_TYPE:
      return <IconNewSection className={className} />;
    default:
      return <IconQuestionMark className={className} />;
  }
};

export const TypeIcon = styled(TypeIconRaw)`
  width: 1em;
  height: 1em;
  vertical-align: middle;
`;
